import { Command } from 'commander';
import ora from 'ora';
import { WorkflowManager } from '../core/workflow-manager';
import { logger } from '../utils/logger';
import { setupWatchMode } from '../utils/watch-helper';
import { withErrorHandling } from '../utils/error-handler';
import fs from 'fs-extra';
import path from 'path';

export function createSyncCommand(): Command {
  const command = new Command('sync');

  command
    .description('View task synchronization status')
    .action(withErrorHandling(async (options) => {
      const manager = new WorkflowManager();

      const spinner = ora('Checking task status...').start();
      
      try {
        const result = await manager.analyzeTasks();
        
        spinner.succeed(`Found ${result.statistics.total} tasks`);
        
        logger.info('');
        logger.info('ℹ️  Tasks are now stored in .workflow/tasks.json');
        logger.info('✨ TODO.md is automatically exported when tasks are updated');
        logger.info('');
        logger.info(`📊 Task Statistics:`);
        logger.info(`  Total: ${result.statistics.total}`);
        logger.info(`  Completed: ${result.statistics.completed} (${result.statistics.completionRate}%)`);
        logger.info(`  In Progress: ${result.statistics.inProgress}`);
        logger.info(`  Pending: ${result.statistics.pending}`);
        
        const todoPath = path.join(process.cwd(), '.workflow/TODO.md');
        if (await fs.pathExists(todoPath)) {
          logger.info('');
          logger.info(`📄 TODO.md is available at: ${path.relative(process.cwd(), todoPath)}`);
        }
      } catch (error) {
        spinner.fail('Failed to check task status');
        throw error;
      }
    }));

  return command;
}